import type { TopicExercises } from "~/features/computer/data/exercises/exercise.types";

export const dsExercises: TopicExercises = {
  mcqs: [
    {
      id: "ds1",
      difficulty: "easy",
      question: "Python list me naya item add karne ke liye konsa function use hota hai?",
      options: ["insert()", "append()", "remove()", "pop()"],
      correctIndex: 1,
      explanation: "Correct answer 'append()' hai kyun ke yeh list ke end me naya item add karta hai. `insert()` specific position ke liye hota hai, jab ke `remove()` aur `pop()` items nikalte hain.",
    },
    {
      id: "ds2",
      difficulty: "easy",
      question: "len() function ka kya kaam hai list me?",
      options: ["Item add karta hai", "Item remove karta hai", "Item check karta hai", "List ki length batata hai"],
      correctIndex: 3,
      explanation: "Correct answer 'List ki length batata hai' hai kyun ke `len()` total items count karta hai. Yeh item add ya remove nahi karta.",
    },
    {
      id: "ds3",
      difficulty: "easy",
      question: "Stack me item remove karne ka operation kya kehlata hai?",
      options: ["Push", "Pop", "Peek", "Add"],
      correctIndex: 1,
      explanation: "Correct answer 'Pop' hai kyun ke stack me last item nikalne ka operation pop hota hai. `Push` add karne ke liye hota hai.",
    },
    {
      id: "ds4",
      difficulty: "easy",
      question: "Queue me item add karne ka operation kya kehlata hai?",
      options: ["Dequeue", "Peek", "Enqueue", "Remove"],
      correctIndex: 2,
      explanation: "Correct answer 'Enqueue' hai kyun ke queue ke end me naya item add karne ko enqueue kehte hain. `Dequeue` remove karne ke liye hota hai.",
    },
    {
      id: "ds5",
      difficulty: "medium",
      question: "Tree ki height ka kya matlab hota hai?",
      options: ["Edges ki number root se deepest node tak", "Nodes ki number root se deepest node tak", "Children ki number root node ke", "Total nodes tree me"],
      correctIndex: 0,
      explanation: "Correct answer 'Edges ki number root se deepest node tak' hai kyun ke tree height aam tor par root se deepest node tak ke path ki edge count ko show karti hai.",
    },
    {
      id: "ds6",
      difficulty: "medium",
      question: "Graph data structure ka best use case kya hai?",
      options: ["To-do list manage karna", "Line of customers", "Social network connections dikhana", "All of the above"],
      correctIndex: 3,
      explanation: "Correct answer 'All of the above' diya gaya hai kyun ke graph connections represent kar sakta hai aur relations ko multiple contexts me model kiya ja sakta hai. Sab se strong example social network hai, lekin question ke hisab se broader answer yahi banta hai.",
    },
  ],
  short: [
    {
      id: "ds-short-1",
      question: "insert() function list me kaise kaam karta hai?",
      answer: "insert(index, value) list ke specific position par item add karta hai.",
    },
    {
      id: "ds-short-2",
      question: "Stack kya hota hai?",
      answer: "Stack ek data structure hai jo LIFO yani Last In First Out principle follow karta hai.",
    },
    {
      id: "ds-short-3",
      question: "Queue kya hoti hai?",
      answer: "Queue FIFO yani First In First Out principle follow karti hai jahan pehla item pehle remove hota hai.",
    },
    {
      id: "ds-short-4",
      question: "enqueue() aur dequeue() me kya farq hai?",
      answer: "enqueue() item add karta hai, jab ke dequeue() item remove karta hai.",
    },
  ],
  long: [
    {
      id: "ds-long-1",
      question: "Python lists ki dynamic size property explain karo",
      solution: "Python list ka size fixed nahi hota. New items add ya remove kiye ja sakte hain, is liye runtime par data ko flexible tareeqe se manage kiya jata hai.",
      steps: [
        "Python list ka size fixed nahi hota.",
        "New items add ya remove kiye ja sakte hain.",
        "Is se data flexible ho jata hai.",
        "Example: list me items runtime par change ho sakte hain.",
      ],
    },
    {
      id: "ds-long-2",
      question: "Stack ke operations real-life example ke sath explain karo",
      solution: "Stack LIFO principle follow karta hai. Plates ki stack me jo plate sab se last rakhi jati hai, woh sab se pehle nikalti hai. Isi logic ko push aur pop operations se samjhaya jata hai.",
      steps: [
        "Stack LIFO principle follow karta hai.",
        "Push: item add karna, jaise plates rakhna.",
        "Pop: last item remove karna.",
        "Example: plate stack me last plate sab se pehle nikalti hai.",
      ],
    },
    {
      id: "ds-long-3",
      question: "Queue ka program explain karo (simple)",
      solution: "Queue FIFO follow karti hai. Naya item end me add hota hai aur pehla item front se remove hota hai. Line me kharay log iski best simple example hain.",
      steps: [
        "Queue FIFO follow karti hai.",
        "Enqueue: item add karna.",
        "Dequeue: pehla item remove karna.",
        "Example: line me kharay log, pehla banda pehle jata hai.",
      ],
    },
    {
      id: "ds-long-4",
      question: "Tree kya hota hai? Iski properties explain karo",
      solution: "Tree hierarchical data structure hai jahan root node top par hoti hai aur us ke neeche children aur levels bante hain. Height structure ki depth ko samjhane me help karti hai.",
      steps: [
        "Tree hierarchical data structure hai.",
        "Root node top par hoti hai.",
        "Har node ke children ho sakte hain.",
        "Levels aur height important concepts hain.",
      ],
    },
    {
      id: "ds-long-5",
      question: "Graph kya hota hai? Directed aur undirected graph me farq batao",
      solution: "Graph nodes aur edges ka structure hota hai. Directed graph me edge ki direction hoti hai, jab ke undirected graph me relation dono taraf se same samjha jata hai.",
      steps: [
        "Graph nodes aur edges ka structure hota hai.",
        "Directed graph me direction hoti hai.",
        "Undirected graph me direction nahi hoti.",
        "Example: social network connections ko graph se dikhaya ja sakta hai.",
      ],
    },
  ],
};
